export default {
    translations: {
      otpDialog: {
        button: "Eliminar contraseña de un solo uso",
        title: "¿Estás seguro de que quieres eliminar tu contraseña de un solo uso?",
        contentEmail: "Correo electrónico de la cuenta:",
        content: "Ten en cuenta que tras la confirmación, la configuración de autenticación multifactor de tu cuenta será eliminada. Tendrá que configurarse nuevamente después.",
        successfullyOtpPass: "Contraseña de un solo uso aceptada exitosamente.",
        successfullyOtpPassContent: "Tu contraseña de un solo uso fue aceptada. Por favor, haz clic en el botón confirmar para redirigir al login y obtener acceso a la aplicación."
      },
      TwoFa:{
        title:"Se envió un código",
        message:"Se envió un código a tu email.",
        button:"Introduce este código"
      },
      Novo: {
        message: 'Nuevo'
      },
      Nome: {
        message: 'Nombre del documento',
        text: 'Nombre',
        folder: 'Nombre de la carpeta',
        username: 'Nombre de usuario',
        workspace: 'Nombre del espacio de trabajo',
        group: 'Nombre del grupo',
        validation: 'Nombre de validación',
        organization: 'Nombre de la organización'
      },
      D4Sign:{
        Confi: 'Configuración D4 Sign',
        SafeBox: 'Caja fuerte',
        Error: 'D4Sign devuelve error',
        Download: 'Descargar documento firmado',
        Wait: 'Espera, preparamos el enlace'
      },
      Sensibility:{
        word:"Sensibilidad",
        higth:"Alto",
        medium:"Medio",
        low:"Bajo"
      },
      Extencao: {
        message: 'Extensión'
      },
      Editar: {
        message: 'Editar'
      },
      Excluir: {
        message: 'Eliminar'
      },
      Clone: {
        message: 'Clonar'
      },
      Iniciais: {
        message: 'Iniciales'
      },
      NomeInterno: {
        message: 'Nombre interno'
      },
      UsuariosAdm: {
        message: 'Usuarios administradores'
      },
      ConfigWork: {
        message: 'Configuración del espacio de trabajo'
      },
      Salvar:{
        message: 'Guardar'
      },
      Deletar: {
        message: "Eliminar"
      },
      Resetar: {
        message: "Restablecer"
      },
      
      SalvarWork: {
        message: 'Guardar espacio de trabajo'
      },
      CloneWork: {
        message: 'Clonar espacio de trabajo'
      },
      Cancelar: {
        message: 'Cancelar'
      },
      Fechar: {
        message: 'Cerrar'
      },
      WorkSalvo: {
        message: 'Espacio de trabajo guardado'
      },
      ErroAoSalvar:{
        message: 'No se pudo guardar'
      },
      CanNotClone:{
        message: 'No se pudo clonar'
      },
      UsuariosSugeridos: {
        message: 'usuarios sugeridos'
      },
      UsuariosNaoEncontradors: {
        message: 'Usuarios no encontrados'
      },
      SalvoOK: {
        message: 'Guardado OK'
      },
      AdmOrg: {
        message: 'Administrador de organización'
      },
      OnlyRead: {
        message: 'Solo lectura'
      },
      SignInWithMicrosoft:{
        message: "Iniciar sesión con Microsoft"
      },
      MinDeCaracteres:{
        message: 'El nombre debe contener 3 o más caracteres'
      },
      MaxDeCaracteres:{
        message:'El nombre debe tener un máximo de 50 caracteres'
      },
      SalvarUsuario:{
        message:'Guardar usuarios'
      },
      ExluirUsuarioValid:{
        message:'¿Estás seguro de que quieres eliminar el usuario'
      },
      UserExcluido:{
        message:'Usuario eliminado.',
        error:'Error: El usuario no puede ser eliminado.'
      },
      Continuar:{
        message:'Continuar'
      },
      Usuarios:{
        message:'Usuarios'
      },
      Org:{
        saveOk:'Organización guardada'
      },
      SalvarOrg:{
        message:'Guardar organización'
      },
      NomeOrg:{
        message:'Nombre de la organización'
      },
      NomeWorkspace:{
        message:'Nombre del espacio de trabajo'
      },
      ExcluidoComSucesso:{
        message:'Eliminado exitosamente'
      },
      EditadoComSucesso:{
        message:'Editado exitosamente'
      },
      ConfigOrg:{
        message:'Configuración de la organización'
      },
      ExcluirOrg:{
        message:'Eliminar organización'
      },
      CertezaExcluir:{
        message:'¿Estás seguro de que quieres eliminar?'
      },
      CertezaExcluirOrganization:{
        message:'¿Estás seguro de que quieres eliminar esta organización?'
      },
      Workspace:{
        permission:"Permisos del espacio de trabajo",
        reader:"Lector",
        writer:"Escritor",
        none:"Ninguno",
        deleteSucess:"Espacio de trabajo eliminado",
        createSucess:"Espacio de trabajo creado",
        cloneSucess:"Espacio de trabajo clonado",
      },
      Item:{
        permission:"Permisos del elemento",
        reader:"Lector",
        writer:"Escritor",
        none:"Ninguno",
        deleteSucess:"Elemento eliminado",
        deleteProblem:"Problema del elemento al eliminar",
        createSucess:"Elemento creado",
        folow:"Seguir padre",
        isFolow:"Seguir",
        dontFolow:"No seguir",
        deleteBtn:"Eliminar ",
        deleteMessage:"¿Estás seguro de que quieres eliminar?",
        deleteMessageFolder: "¿Estás seguro de que quieres eliminar la carpeta?",
        deleteMessageFile: "¿Estás seguro de que quieres eliminar el archivo?",
        deleteDescription: "Confirma si realmente deseas enviar {{itemName}} a la papelera. Podrás restaurarlo posteriormente.",
        setDraft:"Borrador",
        setRelease:"Liberación",
        d4SignVersion:"Obtener versión firmada",
        undoDraft:"Deshacer borrador",
        folder: "Carpeta"
      },
      CertezaExcluirWorkspace:{
        message:'¿Estás seguro de que quieres eliminar este espacio de trabajo?'
      },
      EscrevaNomeOrg:{
        message:'Introduce el nombre de la organización'
      },
      NomeIncorreto:{
        message:'Nombre incorrecto'
      },
      Organizacoes:{
        message:'Organizaciones'
      },
      GrupoSalvo:{
        message:'Grupo guardado'
      },
      AlterarUsuarios:{
        message:'Cambiar usuarios'
      },
      SalvarGrupo:{
        message:'Guardar grupo'
      },
      GrupoExcluido:{
        message:'Grupo excluido.'
      },
      CertezaExcluirGrupo:{
        message:'¿Estás seguro de que quieres eliminar el grupo?'
      },
      Adicionar:{
        message:'Agregar'
      },
      AdicionarUsuario:{
        message:'Agregar usuario'
      },
      UsuarioDoGrupo:{
        message:'Usuarios del grupo'
      },
      Grupos:{
        message:'Grupos'
      },
      TiposDeDocumento:{
        message:'Tipos de documento'
      },
      ValidationRule: {
        menu: "Reglas de validación",
        errorFind: "No se encontró la regla de validación",
        saveOk: "Regla de validación guardada",
        error: "Error al guardar",
        addActivity: "Agregar actividad del flujo de trabajo",
        backOperationLabel: "Etiqueta para volver",
        forwardOperationLabel: "Etiqueta para avanzar",
        dinamic: "Responsable dinámico",
        erroName: "El nombre no debe estar vacío",
        erroBackOperationLabel: "La etiqueta de volver no debe estar vacía",
        erroForwardOperationLabel: "La etiqueta de avanzar no debe estar vacía",
        erroItensTagUser: "Debe haber al menos un responsable",
        doYouWantToRemoveTheValidationRuleUsedOnTheseFiles: "¿Está seguro de que desea eliminar esta regla de validación? Ya no será posible agregar documentos a ella. Los documentos que ya están en este flujo continuarán hasta ser liberados.",
        erroTermTypes: "Error al buscar los tipos de plazo",
        NoTerm: "Sin plazo",
        UserTerm: "Plazo definido por el usuario",
        ActivityTerm: "Plazo definido en la actividad",
        AddNewActivity: "Agregar nueva actividad",
        ActivityDescriptor: "Cree una nueva regla de validación para garantizar que los datos cumplan con los criterios establecidos.",
        Consensual: "Aprobación consensuada",
        newValidationRule: "Nueva regla de validación",
        saveValidationRule: "Guardar regla de validación",
        validationRuleInformation: "Información de la regla",
        validationRuleName: "Nombre de la regla",
        validationRuleDescription: "Descripción",
        validationActivity: "Actividades de la regla",
        validationRuleSteps: "Especifique los pasos que el documento debe seguir a lo largo del flujo de actividad",
        MoveUp: "Mover hacia arriba",
        MoveDown: "Mover hacia abajo",
        RemoveLines: "Eliminar líneas",
        ActivityName: "Nombre de la actividad",
        ActivityResponsable: "Responsable",
        ActivityTermT: "Plazo",
        EditInformation: "Editar información",
        DeleteVr: "¿Realmente desea eliminar la regla de validación?",
        ConfirmDelete: "Confirme si realmente desea eliminar la regla de validación.",
        AprovalAct: "Actividad de aprobación",
        AssignAct: "Actividad de firma",
        AssignActError: "La actividad de firma no puede tener más de un responsable.",
        ValidationruleListTitle: "Regla de validación",
        ValidationRuleListDescription: "Las reglas de validación son criterios establecidos para verificar si los datos cumplen con los requisitos.",
        ValidationRuleListCreateButton: "Crear regla de validación",
        SelectUser: "Seleccionar usuario...",
        NoValidationRule: "No se ha configurado ninguna regla de validación.",
        NoValidationRuleText: "Defina criterios para validar los datos correctamente."
      },
      Empity:{
        message:'Vacío'
      },
      Arvore:{
        message:'Árbol'
      },
      Configuracoes:{
        message:'Configuraciones'
      },
      Expandir:{
        message:'Expandir'
      },
      Diminuir:{
        message: 'Reducir'
      },
      Sair:{
        message:'Cerrar sesión'
      },
      AlteradoComSucesso:{
        message:'Cambiado exitosamente'
      },
      AssinadoComSucesso: {
        message: "firmado exitosamente"
      },
      FinalizadoComSucesso: {
        "message": "Documento concluido."
      },
      AlgoErradoAconteceu: {
        message:'Algo salió mal'
      },
      SenhasNaoBatem:{
        message:'las contraseñas no coinciden'
      },
      CodigoNaoEncontrado:{
        message:'Código no encontrado.'
      },
      SemCodigo:{
        message:'Sin código'
      },
      Senha:{
        message:'Contraseña',
        newPassword: 'Nueva contraseña',
        typeYourPassword: "Introduce tu contraseña...",
        typeYourPasswordAgain: "Introduce tu contraseña nuevamente...",
        newPasswordRequirements: "La contraseña debe tener al menos 6 caracteres, con una letra mayúscula, un carácter especial y un número."
      },
      ConfirmarSenha:{
        message:'Confirmar nueva contraseña'
      },
      Enviar:{
        message:'Enviar'
      },
      Confirmar:{
        message:'Confirmar'
      },
      IrParaLogin:{
        message:'Ir al login',
        message2: 'Ir al login'
      },
      Entrar:{
        message:'Entrar',
        forgotPassword:'Olvidé la contraseña',
        codPage:"Ir a la página de código de email",
        characterMinimun: "Caracteres mínimos",
        specialcharacters: "Carácter especial",
        oneNumber: "Un número",
        capitalLetter: "letra mayúscula"
      },
      InsiraEmail:{
        message:'Introduce tu email registrado'
      },
      InsiraSenha:{
        message:'Introduce tu contraseña registrada'
      },
      Code:{
        message:'Código',
        acepted:'Código aceptado',
        header:'Código de email'
      },
      AccessCode: {
        message: 'Acceder por código',
        label: 'Código de acceso',
        info: '¿Has recibido un código de acceso para acceder a la plataforma? Introduce este código en el campo de abajo.'
      },
      LembrarDeMim:{
        message:'Recordarme'
      },
      EsqueceuSenha:{
        message:'¿Olvidaste tu contraseña?'
      },
      UsuarioOuSenhaIncorretors:{
        message:'Usuario o contraseña incorrectos'
      },
      UsuarioOuCodeIncorretors:{
        message:'Usuario o código incorrectos'
      },
      DoitLogin:{
        message:'Hacer login',
        sucess:"Código aceptado"
      },
      Upload:{
        done:'Finalizado',
        error:'Ocurrió un error',
        file:"Archivo",
        folder: "Subir carpeta",
        newFolder:"Carpeta",
        permission:"Permiso",
        permissionGroup:"Permisos de grupos",
        permissionUser:"Permisos de usuarios",
        notEnoughStorage: "No hay suficiente almacenamiento"
      },
      NotFound:{
        message: "No encontrado"
      },
      Datadamodificacao:{
        message:"Creado"
      },
      Modificadopor:{
        message:"Modificado por"
      },
      Tamanhodoarquivo:{
        message:"Tamaño"
      },
      Folder:{
        save:"Guardado exitosamente",
        toSave:"Cambiar"
      },
      DownloadFileError:{
        message:"Error en la descarga"
      },
      ReleaseError:{
        message:"Error al establecer liberación"
      },
      DraftError:{
        message:"Error al establecer borrador"
      },
      ArcinvingError:{
        message:"Error al establecer archivo"
      },
      SucessMove:{
        message:"¡Archivo movido exitosamente!",
        error:"¡El archivo no se movió!"
      },
      Start:{
        message:"Inicio"
      },
      Action:{
        message:"Acción",
        send:"Enviar a regla de validación"
      },
      ErrorMove:{
        message:"¡Error al mover!"
      },
      Revisao:{
        term:"Revisión",
        tracker:"Rastreador de actividad",
        time:"Tiempo",
        ipUser:"IP",
        name:"Nombre del usuario",
        message:"Mensaje",
        noEntries:"Sin entradas"
      },
      DownloadSuccess:{
        message:"¡Descargado exitosamente!"
      },
      DraftDate:{
        message:"Fecha de creación"
      },
      Atualizar:{
        message:"Actualizar"
      },
      Description:{
        message:"Descripción"
      },
      CertezaExcluirDocumentType:{
        message:'¿Estás seguro de que quieres eliminar este tipo de documento?'
      },
      DocumenType:{
        deleteSucess:"Tipo de documento eliminado",
      },
      New:{
        female:"Nueva",
        male:"Nuevo"
      },
      ValidationRules:{
        NewActivity:"Nueva actividad",
        Deleted:"¿Estás seguro de que quieres eliminar esta regla de validación?",
        DeletedOk:"Regla de validación eliminada",
        RemovedOK:"Regla de validación removida"
      },
      Select:{
        message:"Seleccionar",
        error:"Error al encontrar parámetros"
      },
      Responsible:{
        message:"Responsable",
        select:"Seleccionar responsable",
        suggestions:"Responsables sugeridos",
        notFound:"No se encontró responsable",
        lessOne:"Mínimo un responsable"
      },
      ActivityName:{
        message:"Nombre de la actividad"
      },
      Pendencias: {
        message: "Pendencias",
        text: "Gestione sus documentos: siga el estado de las pendencias, aprobaciones y rechazos de forma simple y eficiente."
      },
      CertezaExcluirPermission:{
        message:'¿Estás seguro de que quieres eliminar este permiso?'
      },
      Label:{
        Back:"Etiqueta de retroceso",
        Forward:"Etiqueta de avance"
      },
      CPF:{
        choice:'D4 Sign',
        invalid:'CPF inválido',
        nextStep:'Validar',
        SaveInServer:'Guardar en el servidor'
      },
      foreign:{
        message:'Extranjero'
      },
      loadMore:{
        text:"Cargar más",
        error:"No se encontraron más reglas de validación"
      },
      Exibir:{
        message:"Ver"
      },
      UsuarioSalvo:{
        message:"Usuario guardado"
      }, 
      Copy:{
        message:'¡Copiado exitosamente!',
        error:'¡Error al copiar!'
      },
      Wait:{
        message:"Esperar"
      },
      ErroMail:"Email inválido",
      SharedFile:{
        Error:"Error en la consulta",
        Menu:"Compartir archivo",
        FileDontShared:"Archivo no compartido",
        ToShare:"Para compartir",
        AddEmail:"Agregar email",
        EndedByDay:"Compartir hasta",
        EndedByAcces:"Compartir hasta usar acceso x veces",
        WithoutEnded:"No expira",
        ErroOnDelete:"Hubo un error al eliminar",
        ErroOnSave:"Hubo un error al guardar",
        NotCheckBox:"Es necesario marcar una casilla",
        ListEmails: "La lista debe tener emails",
        HasWatermark: "Compartir con marca de agua"
      },
      TextField:{
        TooltipTitle: "Haz clic en el botón para agregar email."
      },
      permissionDriveOrg:{
        message:"Asignar permiso a drive",
        permission:"Permiso de drive"
      },
      renameItem:{
        message:"Renombrar ",
        error:"Error al renombrar"
      },
      editItem:{
        message:"Editar "
      },
      owner:{
        message:"Propietario de la carpeta"
      },
      permissionFolder:{
        message:"Permisos"
      },
      Visualizador:{
        message:"Visualizador"
      },
      PermicoesItem:{
        message:"Permisos del elemento",
      },
      Move:{
        moveBy: "Mover a",
        message:"Mover ",
        to:" a ",
        toRoot:"Mover a raíz",
        root:" a raíz",
      },
      AcaoExecutada:{
        message:"Acción ejecutada"
      },
      RevisaoDocument:{
        message:"Revisión del documento"
      },
      Usuario:{
        message:"Usuario"
      },
      DateAction:{
        message:"Fecha de acción"
      },
      ErrorDate:{
        Begin:"La fecha de inicio no puede ser mayor que la fecha de fin.",
        End:"La fecha de fin no puede ser menor que la fecha de inicio."
      }, 
      Arquivar:{
        message:"Archivar"
      },
      ResetPasswordRequest:{
        message:"Redefinir contraseña"
      },
      InvalidEmail:{
        message:"Email inválido"
      },
      EmailSent:{
        message:"Email enviado"
      },
      NewResp:{
        message:"Seleccionar nuevo responsable",
      },
      ArqResp:{
        message:"Archivos de los cuales el usuario es responsable.",
      },
      SelectResp:{
        message:"Selecciona el nuevo usuario para la regla de validación.",
      },
      Organizador:{
        message:"Organizador",
      },
      CalendarLabel:{
        message: "Vencimiento",
        toolTipMessage:"El vencimiento define el período de validez de un documento.",
        From: "Desde:",
        To: "Hasta:"
      },
      CalendarButtonToday:{
        TodayButton:"Hoy",
      },
      ReturnEmptyTracker:{
        MessageSnack:"Rastreador no encontrado",
      },
      NameExist:{
        message:"El nombre ya existe"
      },
      Rejeitado:{
        message:"¡Rechazado exitosamente!"
      },
      StroageInformation:{
        bookcase:"Estantería",
        shelf:"Estante",
        position:"Posición / Caja",
        menu:"Ubicación física",
        additionalInformation: "Información adicional"
      },
      Delete:{
        message:"Eliminar",
      },
      SelectValidationRule:{
        message:"Selecciona la regla de validación",
      },
      Remove:{
        message:"Remover"
      },
      NotificationEmail:{
        message:"Recibir notificación por email"
      },
      EditFolder: {
        title: "Editar Carpeta",
        information: "Información",
        folderName: "Nombre de la carpeta",
        sensitivity: "Sensibilidad",
        owner: "Propietario",
        notifications: "Notificaciones",
        updateInformation: "Actualizar información",
        receiveEmailNotifications: "Recibir notificaciones por correo electrónico."
      },
      ActionsInBatch:{
        message:"Acciones en lote"
      },
      FilesWentToRelease:{
        message:"Los archivos fueron a liberación"
      },
      ErrorWhenUpdatingToRelease:{
        message:"Error al actualizar a liberación"
      },
      FilesWentToDraft:{
        message:"Los archivos fueron a borrador"
      },
      ErrorWhenUpdatingToDraft:{
        message:"Error al actualizar a borrador"
      },
      UploadAsRelease:{
        message:"Subir como liberación"
      },
      OrganizerCannotDelete:{
        message:"El organizador no puede eliminar"
      },
      EditorCannotDelete:{
        message:"El editor no elimina"
      },
      "EditorCannotSeeRevision": {
        message:"El editor no puede ver la revisión"
      },
      Undo:{
        message:"Deshacer"
      },
      ConfirmTheDiscardOfTheDraft:{
        message:"¡Esta acción es irreversible! ¿Confirmas el descarte del borrador?"
      },
      Term: {
        message:"Fecha de vencimiento",
        select:"Seleccionar término",
        days:"Días",
        addTerm:"Agregar tipo de plazo",
        current: "Fecha límite",
        on: "término positivo",
        out: "plazo vencido",
        noDeadline: "Sin plazo"
      },
      FileDownload: {
        message:"Descarga de archivo"
      },
      NoViewerModal: {
        title: "No se puede ver este archivo",
        content: "El archivo que intentas previsualizar no tiene una vista previa para lectura. Para poder verlo, haz clic en el botón de abajo para descargar y acceder al archivo."
      },
      informationModal:{
        message:"Información a quien se envió la validación"
      },
      termRule:{
        message:"Elige un plazo para la regla de validación.",
        select:"Seleccionar término"
      },
      tag:{
        editMessage:"¡Etiqueta editada exitosamente!",
        addMessage:"¡Etiqueta agregada exitosamente!",
        errorEdit:"¡Error al editar etiqueta!",
        errorAdd:"¡Error al agregar etiqueta!",
        notFound:"Etiquetas no encontradas",
        new:"Nueva etiqueta",
        suggested:"Etiquetas sugeridas",
        edit:"Editar etiquetas",
        add:"Agregar etiquetas",
        insertMessage:"Inserta etiquetas en archivos y carpetas para fácil acceso y encuentra fácilmente lo que buscas.",
        LoadingResults:"Cargando más resultados...",
        save:"Guardar información",
        cancel:"Cancelar",
        nameFile:"Nombre del archivo",
        descFile:"Descripción del archivo",
        semDesc:"Sin descripción",
        fileTag:"Etiquetas del archivo",
        tagExist:"El nombre ya existe",
        messageTag:"La etiqueta ya existe",
        NoTag: "Sin etiquetas"
      },
      validationRulePanel: {
        select: "Selecciona la regla de validación que coincida con la necesidad actual del documento.",
        execution: "Ejecución",
        selectUser: "Selecciona la persona responsable que ejecutará la regla de validación seleccionada arriba.",
        alreadySetConfig: "Configuraciones ya asignadas en la regla de validación.",
        alreadySetValidation: 'Las configuraciones de validación ya han sido asignadas. Haz clic en "Enviar al responsable" para completar.',
        sendToResponsible: "Enviar al responsable.",
        OkUnderstand: "Ok, entiendo",
        validationRuleSubmit: "Regla de validación enviada exitosamente.",
        validationRuleData: "La regla de validación ha sido enviada a la persona responsable que coincide con los datos listados abajo.",
        responsible: "Responsable",
        withTerm: "Sin término.",
        emailWrong: "El elemento que estaba pendiente fue completado exitosamente. Puedes ignorar el email recibido y cerrar esta ventana.",
        responsableError: "El responsable debe ser establecido.",
        norVrFounded: "No se encontró regla de validación.",
        title: "Regla de validación",
        termError: "Un plazo debe ser establecido."
      },
      substituir:{
        message:"Reemplazar"
      },
      DetailDocumentPage: {
        Actions: "Acciones",
        Save: "Guardar",
        Description: "Sin descripción...",
        ModDate: "Fecha modificada",
        ModResp: "Gestor del documento",
        Term: "Término",
        NoTerm: "Sin término...",
        Visualization: "Visualización",
        ActivityTracker: "Rastreador de actividad",
        Location: "Ubicación física",
        Reviews: "Revisiones"
      },
      WhatAreYouLookingFor: {
        message: "¿Qué estás buscando..."
      },
      Search: {
            message: "Buscar..."
        },
      Wizard: {
        organization: "Organización",
        password: "Contraseña",
        confirmPassword: "Confirma tu contraseña",
        welcome: "¡Bienvenido!",
        return: "Atrás",
        continue: "Continuar",
        conclude: "Concluir registro",
        name: "Nombre",
        addUsers: "Agregar",
        errorUsers: "Número de usuarios inválido",
        emailInfo:"Agrega hasta 5 empleados para que sean parte del ambiente de trabajo de la empresa",
        descriptionEnd:"Verifica si la información es correcta. Si es así, haz clic en \"",
        descriptionEndBold:"Concluir registro",
        descriptionEndSecond:"\".",
        maxUserlength: "Máximo de usuarios excedido",
        fillAllFields: "Rellena todos los campos correctamente",
        emailAlreadyInList: "Email ya está en la lista."
      },
      Login: {
        forgotPass: "Olvidé mi contraseña",
        password: "Contraseña",
        goToEmailPage: "Ir a la página de email",
        accessAcount: "Entra a tu cuenta",
        helloAgain: "¡Hola de nuevo! Rellena los campos de texto con tus datos para acceder a tu cuenta.",
        putYourNewPass: "Introduce tu nueva contraseña.",
        fillTheFieldsDown: "Rellena los campos de abajo con tu nueva contraseña.",
        forgotYourPass: "¿Olvidaste tu contraseña?",
        fillTheEmailRegistered: "Rellena el campo de texto de abajo con tu email registrado para recuperar tu contraseña.",
        typeYourEmail: "Escribe tu email...",
        typeYourPassword: "Escribe tu contraseña...",
        accessWithCode: "Acceder con código.",
        doYouReceived: "¿Recibiste el código de acceso para entrar a la aplicación? Inserta tu código en el campo de texto de abajo.",
        yourAccessCode: "Código de acceso.",
        typeYourAccessCode: "Escribe tu código de acceso...",
        privacyPolicy: "Política de privacidad",
        allRights: "Todos los derechos reservados.",
        checkYourEmail: "Revisa tu email.",
        confirmationEmail: "Si tu email es válido, se envió un enlace para cambiar tu contraseña.",
        didntRecieved: "¿No recibiste tu email?",
        clickHereToResend: "Haz clic aquí para reenviar",
        alrightUnderstand: "Está bien, entiendo.",
        qrcodeTitle: "Código QR generado",
        qrcodeSub: "Escanea el código QR de abajo para configurar tu aplicación.",
        otpTittle: "Contraseña de un solo uso",
        otpSub: "Introduce el código que obtuviste en tu autenticador.",
        OtpMessage: "Contraseña de un solo uso",
        qrcodeRedirect: "Después de escanear el código QR, debes hacer clic en el botón de abajo para insertar tu contraseña de un solo uso.",
        oneUsePassword: "Introduce una contraseña de un solo uso.",
        otpErrorMessage: "La contraseña de un solo uso debe ser definida",
        error: "Problema de login",
        oneTimePasswordError: "Tu contraseña de un solo uso no fue aceptada, por favor inténtalo de nuevo.",
        oneTimePasswordSucess: "Tu contraseña de un solo uso fue aceptada exitosamente.",
        microsoft: "Continuar con",
        confirm: "Confirmar"
      },
      Privileges: {
            ModifyUser: "Modificar Privilegio (Usuario)",
            AddUser: "Agregar Privilegio (Usuario)",
            AddGroup: "Agregar Privilegio (Grupo)",
            DefineNewPrivilege: "Defina el nuevo privilegio del usuario de acuerdo con una de las opciones a continuación; Privilegio actual:",
            ModifyGroup: "Modificar Privilegio (Grupo)",
            DefineNewPrivilegeGroup: "Defina el nuevo privilegio del grupo de acuerdo con una de las opciones a continuación; Privilegio actual:",
            VerifyUserPrivilegeCaption: "Verifique los usuarios que poseen algún privilegio en",
            Item: "Ítem",
            Workspace: "Espacio de trabajo",
            IsSubFolder: "Esta carpeta es una subcarpeta; no es posible modificar privilegios de subcarpetas.",
            Users: "Usuarios",
            Groups: "Grupos",
            Add: "Agregar",
            Edit: "Editar",
            DefineWithOptions: "Defina el privilegio del usuario de acuerdo con una de las opciones a continuación:",
            DefineWithOptionsGroup: "Defina el privilegio del grupo de acuerdo con una de las opciones a continuación:",
            Privileges: "Privilegios",
            DefinePrivilege: "Definir Privilegio",
            Organizer: "Organizador",
            Reader: "Lector",
            Common: "Común",
            Editor: "Editor",
            None: "Nenhum",
            OrganizerBehavior: "No tiene acceso a privilegios administrativos y no puede cambiar la carpeta raíz, pero puede crear nuevas subcarpetas y documentos, además de editar y eliminar contenidos existentes. Las subcarpetas heredarán automáticamente los mismos privilegios de los grupos y usuarios de la carpeta raíz.",
            ReaderBehavior: "Realiza ediciones en la herramienta y tiene acceso a las funcionalidades. No puede crear ni eliminar estructuras de carpetas.",
            EditorBehavior: "Estos usuarios solo consultan y visualizan los documentos en los Espacios de trabajo permitidos.",
            CommonBehavior: "Usuario que solo pertenece al espacio de trabajo, pero no tiene privilegios hasta que alguien se los conceda.",
            ExcludeTitle: "¿Realmente desea eliminar este permiso?",
            ExcludeContent: "Al eliminar el permiso, el usuario será removido del espacio de trabajo y de las carpetas en las que tiene permisos.",
            Confirm: "Confirmar",
            Cancel: "Cancelar",
            Name: "Nombre",
            Email: "Correo electrónico",
            Phone: "Teléfono",
            Privilege: "Privilegio",
            Participants: "Usuarios",
            Owner: "Dono da pasta",
            NoPrivileges: "Sin privilegios asignados.",
            NoPrivilegesText: "Configure los privilegios necesarios para que el usuario acceda a los recursos del sistema.",
            NoPrivilegesGroupText: "Configure los privilegios necesarios para que el grupo acceda a los recursos del sistema."
        },
        AccountAndSubscription: {
            RecoverySubscription: "Recuperar suscripción",
            CanceledSubscriptionCaption: "Su suscripción está cancelada. Para más detalles, contacte con el soporte.",
            IdInvoice: "Identificador de la factura",
            Username: "Email de usuario",
            StatusInvoice: "Estado de la factura",
            CancelSubscription: "Cancelar suscripción",
            ClientServices: "Servicios del cliente",
            Others: "Otros",
            NoFeatures: "Funciones inexistentes",
            SwitchServices: "Voy a cambiar de servicio",
            AddCancelComments: "Agregue comentarios para que podamos mejorar nuestro software.",
            RecoverySubscriptionDialogContent: "Recupere su suscripción cancelada haciendo clic en el botón de recuperar. Sus elementos suscritos se mantendrán y podrá utilizar el software normalmente. (Se recuperará el MISMO plan contratado y la facturación será automática.)",
            CancelSubscriptionMotivate: "¿Por qué motivo desea cancelar su suscripción?",
            Payment: "Pago",
            EditPaymentCard: "Editar tarjeta de crédito",
            Copy: "Copiado",
            PaymentLinkGenerated: "Enlace de actualización de pago generado",
            ExpiresIn: "Expira en",
            CardNumber: "Número de tarjeta",
            Plan: "Plan",
            Storage: "Storage",
            Users: "Users",
            ContractValue: "Value",
            SwitchPlansEveryMoment: "You can change your plan at any time",
            Category: "Category",
            AccountPlan: {
                Free: "Gratuito",
          },
          LabelStepsPayments : {
            ValidatingData: "Validando datos",
            CreatingPaymentMethod: "Creando método de pago",
            UpdatingPaymentMethod: "Actualizando método de pago",
            Finalizing: "Finalizando"
          },
          ProcessingNewPaymentMethod: "Procesando su nuevo método de pago",
          PaymentMethodUpdatedSuccessfully: "¡Método de pago actualizado con éxito!",
          PaymentMethodUpdatedSuccessMessage: "Su método de pago ha sido actualizado con éxito. Gracias por continuar con KeyDrive.",
          ClickToLogoutAndRefresh: "Haga clic para salir y actualizar",
          TryAgain: "Intentar de nuevo",
          ErrorProcessingPaymentMethod: "Error al procesar su nuevo método de pago",
          WhatToDoNow: "¿Qué hacer ahora?",
          CheckCardDetailsAndTryAgain: "Verifique los datos de la tarjeta e intente de nuevo",
          EnsureAllFieldsFilledCorrectly: "Asegúrese de que todos los campos estén completados correctamente",
          ContactSupportIfProblemPersists: "Si el problema persiste, contacte al soporte",
          CardDetails: "Datos de la Tarjeta",
          BillingAddress: "Dirección de Facturación",
          WantToCancelNow: "Quiero cancelar ahora",
          Back: "Volver",
          SubscriptionCancelledSuccessfully: "¡Su suscripción ha sido cancelada con éxito!",
          Confirm: "Confirmar",
          CancelSubscriptionImmediatelyWarning: "Al hacer clic en el botón confirmar, su suscripción será cancelada inmediatamente y perderá el acceso a las funciones de pago.",
          CancelSubscriptionRightNow: "Cancelar suscripción ahora mismo"
        },
        Signture: {
            UnderSignture: "Usted está bajo la suscripción de un plan",
            Guest: "Convidado",
            SigntureCanceledContent: "Estás utilizando Keydrive con una suscripción cancelada. Para continuar utilizando el sistema, por favor elige un nuevo plan.",
            SigntureCanceledTitle: "Tu suscripción ha sido cancelada",
            EditPaymentMethod: "Editar método de pago",
            Owner: "Propietario"
        },
        Paywall: {
            title: "¡Has alcanzado el máximo permitido!",
            workspaceStart: "Solo puedes tener ",
            workspaceBold: "un Workspace en el plan gratuito. ",
            workspaceEnd: "Ponte en contacto con el soporte y solicita una actualización en el plan de tu Organización.",
            usersStart: "Solo puedes tener ",
            usersBold: "tres usuarios en el plan gratuito. ",
            usersEnd: "Ponte en contacto con el soporte y solicita una actualización en el plan de tu Organización.",
            storageStart: "Solo puedes utilizar hasta ",
            storageBold: "4GB de almacenamiento en el plan gratuito. ",
            storageEnd: "Ponte en contacto con el soporte y solicita una actualización en el plan de tu Organización.",
            storageWithAdminContactStart: "Solo puedes utilizar hasta ",
            storageWithAdminContactBold: "4GB de almacenamiento en el plan gratuito. ",
            storageWithAdminContactEnd: "Ponte en contacto con el usuario administrador y solicita una actualización en el plan de la Organización.",
            validationRuleStart: "Solo puedes tener ",
            validationRuleBold: "una Regla de validación en el plan gratuito. ",
            validationRuleEnd: "Ponte en contacto con el soporte y solicita una actualización en el plan de tu Organización.",
            upgrade: "Actualizar",
            gotIt: "Entendido",
            error: "Error al buscar la información de la organización, inténtalo de nuevo"
        },
        FileUploader: {
            UploadOfFiles: "Carga de archivos",
            Of: "de",
            FilesInProgress: "archivos en progreso",
            TitleModalCloseUpload: "Hay archivos en progreso... ¿Cancelar de todos modos?",
            SubtitleModalCloseUpload: "Parece que hay archivos que aún se están cargando. Confirme si desea cerrar y cancelar las cargas en progreso.",
            TextButtonReject: "¡No! Continuar cargas...",
            TextButtonAccept: "Sí, cancelar cargas.",
            Waiting: "Espere...",
            UploadStatus: {
            Success: "Carga exitosa",
            Error: "Error en la carga",
            Canceled: "Carga cancelada",
            Warning: "Advertencia en la carga",
            Others: "Error desconocido"
            }
        },
      InvalidCaptcha:{
        message:"Captcha inválido"
      },
      ResetPasswordSuccess: {
        title: "Contraseña cambiada exitosamente",
        subtitle: "Tu contraseña ha sido cambiada exitosamente, recuerda mantenerla bajo llave. Haz clic en el botón de abajo para acceder al login."
      },
      Reset:{
        message:"Restablecido exitosamente."
      },
      AutoArquivar:{
        message:"Auto archivar"
      },
      ParaArquivar:{
        message:"Para archivar"
      },
      Temporality:{
        message:"Temporalidad",
        subtitle: "Siga los plazos y estados con claridad, analizando la evolución temporal para una mejor gestión y toma de decisiones.",
        panelTitle:"Agregar temporalidad",
        dateTemp:"Auto archivar en:",
        select: "Seleccionar temporalidad",
        descriptionTemporalityMenu: "Selecciona uno de los espacios de trabajo de abajo para ver el reporte de temporalidad.",
        Expired: "Vencido",
        Filed: "Archivado",
        Signed:"Firmado",
        Removed: "Removido"
    },
    TemporalityComboBox: {
      ExplanatoryText: "Cambiar estado a",
      TooltipHostDefalt: "El estado define el estado, posicionamiento o situación del documento en el proceso en el que se encuentra.",
      TooltipHostExpired: 'El estado "Vencido" definirá que el plazo ha pasado para realizar alguna acción relacionada con el documento seleccionado.',
      TooltipHostArquived: 'El estado "Archivado" guardará e inactivará el documento. Puede ser activado y reanudado nuevamente en cualquier momento.',
      TooltipHostDraft: 'El estado "Borrador" se define como borrador, es decir, el elemento estará en un estado inicial y necesitará someterse a una nueva validación.',
      PlaceHolder: "Seleccionar"
    },
    dataArqchive: {
      message: "Fecha de archivo"
    },
    WithoutRule: {
      withoutRule: "Sin regla.",
      withoutDesc: "Sin descripción"
    },
    ViwerInfo: {
      cannotView: "No se puede ver este archivo",
      notPreview: "El archivo que intentas ver no tiene vista previa para leer. Para poder verlo, haz clic en el botón de abajo para descargar y acceder al archivo.",
      downloadFile: "Descargar el archivo.",
      successfullyDownload: "Descarga exitosa."
    },
    DataTableHeaders: {
      Reviews: "Revisiones",
      Actions: "Acciones",
      Users: "Usuarios",
      Date: "Fecha de creación",
      DueDate: "Fecha de vencimiento",
      Name: "Nombre",
      Description: "Descripción",
      ExplanatoryText: "Fecha en que se ejecutará la acción",
      TooltipHost: "El vencimiento define el período de validez de un documento."
    },
    FilterTables: {
      OrdenationDate: "Ordenar por fecha",
      Reviews: "Revisiones",
      AlphaOrder: "Orden alfabético",
      OrderByUsers: "Ordenar por usuarios",
      OrderByMessages: "Ordenar por mensajes",
      Descending: "Descendente",
      Ascending: "Ascendente",
      apply: "Aplicar",
      clearFilters: "Limpiar filtros"
    },
    DetailPhLocation: {
      TypeHereLocal: "Escribe aquí... (ej., Habitación, Edificio, Piso)",
      TypeHereBookcase: "Escribe aquí... (ej., Estantería verde, Estantería no. 3)",
      TypeHereShelf: "Escribe aquí... (ej., Estante no. 3, Cuarto estante de arriba a abajo)",
      TypeHerePosition: "Escribe aquí... (ej., Caja roja, Archivo encima de la mesa)",
      TypeHereAdditionalInformation: 'Escribe aquí...',
      SaveButton: "Guardar cambios",
      CancelButton: "Cancelar cambios"
    },
    UnableToReturnItemTemporality: {
      message: "No se puede devolver la temporalidad del elemento"
    },
    SelectTemporality: {
      message: "Seleccionar temporalidad"
    },
    SelectDocumentExpiration: {
      message: "Seleccionar vencimiento del documento"
    },
    DocumentValidity: {
      message: "Validez del documento"
    },
    Validity: {
      message: "Validez"
    },
    EmptyTemporalityField: {
      message: 'Campo de temporalidad vacío'
    },
    EmptyDocumentValidityField: {
      message: 'Campo de validez del documento vacío'
    },
    RetroactiveDueDate: {
      message: 'Fecha de vencimiento retroactiva'
    },
    HasExpired: {
      message: 'Ha vencido'
    },
    Option: {
      message: "Establecer estado a"
    },
    RemoveTemporality: {
      message: "Remover temporalidad"
    },
    Reload: {
      message: "Recargar"
    },
    AssignServiceUser: {
      message: "Asignar usuario de servicio"
    },
    ErrorReceivingAdminUsers: {
      message: "Error al recibir usuarios administradores"
    },
    Dashboard: {
      general: "General",
      storageLimit: "Tu límite de almacenamiento es",
      generalDataUsage: "Uso general de datos",
      storageInUse: "Almacenamiento en uso",
      freeStorage: "Almacenamiento libre",
      wsDataUsage: "Uso de datos en espacios de trabajo",
      storageUseWithoutContract: "No hay almacenamiento máximo establecido",
      OrganizationDoesntHaveWorkspace: "La organización no tiene ningún espacio de trabajo.",
      storagePerUser: "Almacenamiento por usuario",
      notFoundgeneralData: "Datos generales no disponibles en este momento.",
      AllUsers: "Todos los usuarios",
      Users: "Usuarios",
    },
    UpgradeCard: {
      needUpgrade: "¿Necesitas un ",
      upgradeSpace: "upgrade de espacio?",
      wantUpgrade: "Quiero un upgrade"
    },
    StorageTypeFile: {
      documents: "Documentos",
      images: "Imágenes",
      videos: "Vídeos",
      others: "Otros"
    },
    FilterRangeUsageStorage: {
      buttonFilter: "Filtro",
      title: "Uso de almacenamiento",
      greaterThan: "Mayor que",
      lessThan: "Menor que",
      clear: "Limpiar",
      apply: "Aplicar",
      valueCannotBeNegative: "El valor no puede ser negativo."
    },
    Dwg: {
      size: "Tamaño",
      palette: "Paleta",
      orientation: "Orientación",
      converterType: "Tipo de convertidor",
      backgroundColor: "Color de fondo",
      title: "Selecciona las opciones de abajo para ver el archivo"
    },
    Selecionar: {
      message: "Seleccionar"
    },
    YourBrowserDoesNotSupportThePrintingFunction: {
      message: "Tu navegador no soporta la función de impresión."
    },
    ChooseColumns: {
      message: 'Filtrar por',
      description: 'Descripción',
      validationRule: 'Regla de validación',
      term: 'Término',
      size: 'Tamaño',
      createdAt: 'Creado en',
      applyFilter: "Aplicar filtro",
      reset: "Restablecer"
    },
    FilterBy: {
      message: "Filtrar por estado",
      toolTipMessage: "El estado define el estado, posicionamiento o situación del documento en el proceso en el que se encuentra.",
      placeholderMessage: "Seleccionar..."
    },
      NoRegistry: {
        title:"No hay filtros seleccionados",
        message: "Selecciona una fecha de vencimiento y un estado para realizar tu búsqueda.",
      },
      WorkspaceItemFlowListing:{
        responsible: "Responsable",
        date: "Fecha",
        progress: "En progreso",
        waiting: "Esperando...",
        by: "Por",
        dynamic: "Responsable dinámico"
      },
      OrganizationMessages: {
        "problemWithResources": "Tenemos algunos problemas para recuperar tus recursos.",
        "resourceAlert": "El contrato no tiene el recurso de llamada de API."
      },
      ErrorViwer:{
        title:"No fue posible ver este archivo",
        description:"Ocurrió un error inesperado al intentar ver. Intenta ver el archivo de nuevo."
      },
      ViwerAutomaticDwg:{
        message:"Generar datos de visualización CAD en segundo plano."
      },
      DuplicateFolder: {
        message:"Duplicar carpeta"
      },
      NameMustNotIncludeEitherSlashes: {
        message: "El nombre no debe incluir \\ ni /"
      },
      MaintainPermissions: {
        message:"Mantener permisos"
      },
      DuplicationOf: {
        message:"Duplicación de"
      },
      CopyDocumentLink: {
        message:"Copiar enlace del documento",
      },
      ItemIdNotFound: {
        message: "ID del elemento no encontrado",
      },
      WithoutPermission: {
        message: "Sin permiso",
      },
      RecicleBin: {
        title: "Papelera de reciclaje",
        subtitle: "Mantén el control: Restaura o elimina permanentemente archivos de la papelera.",
        fileName: "Nombre del archivo",
        userName: "Responsable",
        date: "Fecha de eliminación",
        confirm: "Confirmar",
        restore: "Restaurar",
        to: "a",
        search: "Buscar...",
        folder: "Carpeta",
        fileRestored: "Archivo restaurado",
        goToFileFolder: "Ir a la carpeta del archivo",
        finishAndClose: "Finalizar y cerrar",
        deletedSuccessTitle: "¡Eliminación completada exitosamente!",
        deletedSuccessHeader: "Revisa abajo los elementos que fueron eliminados permanentemente.",
        emptyRecycleBinPartA: "Papelera de reciclaje vacía",
        emptyRecycleBinPartB: "Parece que alguien finalmente sacó la basura.",
        emptyRecycleBinPartC: "No hay archivos o carpetas aquí.",
        emptyRecycleBinPartD:"No hay carpetas aquí",
        selectOneWorkspace:"Selecciona un espacio de trabajo para ver las carpetas.",
        deleteConfirm: "Confirma si realmente quieres remover permanentemente el archivo",
        deleteConfirmTwo: "Una vez removido, no puede ser recuperado.",
        deleteTitleList: "¿Quieres remover todos los elementos?",
        deleteConfirmList: "Confirma si realmente quieres remover permanentemente todos los elementos listados abajo. Una vez removidos, no pueden ser recuperados.",
        cancel: "Cancelar",
        deleteSelected: "Remover archivos",
        restoreListButton: "Restaurar archivos",
        restoreTitleConfirm: "¿Quieres restaurar el archivo?",
        restoreTitleConfirmList: "¿Restaurar todos los elementos?",
        restoreConfirmList: "Confirma si realmente quieres restaurar todos los elementos listados abajo. Finalmente, define el destino de almacenamiento.",
        deleteModalTitle: "¿Quieres remover el archivo?",
        headerRestorePartA: "Para restaurar el archivo",
        headerRestorePartB: "define el destino de almacenamiento.",
        headerRestoreLastConfirmation: 'Revisa la información de restauración abajo y confirma si la ruta de restauración es correcta. Si es incorrecta, haz clic en "Cancelar".',
        headerRestoreSuccessTitle: "¡Archivo restaurado exitosamente!",
        headerRestoreSuccessPartA: "El archivo",
        headerRestoreSuccessPartB: "fue restaurado exitosamente. Revisa abajo la",
        headerRestoreSuccessPartC: "información para encontrarlo después de la restauración.",
        removedBy: "Removido por",
        
        filter: "Filtros",
        files: "Archivos",
        select: "Seleccionar...",
        viewMyFiles: "Ver mis archivos",
        seeAllFiles: "Ver todos los archivos",
        current: "(Actual)",
        defalt: "(Por defecto)",
        reset: "Restablecer",
        applyFilter: "Aplicar filtro",

        compareFiles: "Comparar archivos",
        ignoreFiles: "Ignorar archivos",
        replaceFiles: "Reemplazar archivos",
        compareFile: "Comparar archivo",
        ignoreFile: "Ignorar archivo",
        replaceFile: "Reemplazar archivo",
        CheckItemsSameNameTitle: "Ya hay elementos con el mismo nombre en el destino",
        headerCheckItemsSameNamePartA: "El destino ya contiene ",
        headerCheckItemsSameNamePartB: " elementos/archivos",
        headerCheckItemsSameNamePartC: " con los mismos nombres. Selecciona",
        headerCheckItemsSameNamePartD: " abajo qué acción te gustaría tomar.",

        compareFilesTitle: "Compara los archivos y elige uno de ellos",
        headerCompareFiles: "Compara los archivos abajo para decidir qué versión quieres mantener.",
        compareFilesTitleList: "Elemento en",

        restoreSuccessListTitleType1: "¡Reemplazo y restauración completados exitosamente!",
        restoreSuccessListTitleType2: "¡Archivos ignorados y restauración completada exitosamente!",
        restoreSuccessListTitleType3: "¡Elementos actualizados exitosamente!",
        headerRestoreSuccessListType1PartA: "El reemplazo y restauración de los elementos fueron completados exitosamente. Ve",
        headerRestoreSuccessListType1PartB: " abajo la lista de archivos y carpetas restaurados.",
        headerRestoreSuccessListType2PartA: "La restauración fue completada. Los archivos con nombres duplicados fueron",
        headerRestoreSuccessListType2PartB: "ignorados. Ve abajo la lista de archivos y carpetas restaurados.",
        headerRestoreSuccessListType3PartA: "Los elementos seleccionados fueron actualizados exitosamente. Revisa abajo la lista",
        headerRestoreSuccessListType3PartB: "con los elementos actualizados.",
        selectedListTooltipText: "Abrir en nueva pestaña",
        deleteConfirmTooltipText: "Eliminar permanentemente archivo",
        restoreConfirmTooltipText: "Restaurar archivo de la papelera"
      },
      NotFoundPage:{
        header: "Página no encontrada",
        body: "Desafortunadamente la página que intentaste acceder no fue encontrada.",
        button: "Volver al inicio",
      },
      LoggedHome: {
        QuickAccessContent: "Guarda tus rutas y archivos usados frecuentemente y accede a ellos rápidamente desde aquí o donde sea que estés.",
        QuickAccessTitle: "Acceso rápido",
        OrganizationsContent: 'Los espacios de trabajo más visitados o favoritos están disponibles justo abajo. Para ver todos, haz clic en "Espacio de trabajo".',
        OrganizationsTitle: "Organizaciones",
        RecentActivities: "Actividades recientes",
        RecentActivitiesContent: 'Accede a actividades realizadas recientemente. Para ver todas, haz clic en "Actualizaciones".',
        FileName: "Nombre del archivo",
        Action: "Acción",
        Responsible: "Responsable",
        LastModification: "Última modificación",
        favoriteSuccess: "marcado como favorito exitosamente.",
        favoriteExclude: "Elemento favorito eliminado.",
        favoriteError: "el favorito ya existe.",
        NoRecentActivities: "No hay actividades recientes",
        MovingOrganization: "Comienza a mover tu organización a través de espacios de trabajo. De esta manera, podrás ver actividades aquí",
        ViewMore: "Ver la lista completa"
      },
      Favorite: {
        SuccessFavorite: "Tu elemento ha sido marcado como favorito exitosamente. Pronto aparecerá en el acceso rápido",
        FailureFavorite: "NNo fue posible marcar tu elemento como favorito. Verifica si ya está marcado como favorito. Si el error persiste, contacta al soporte",
        RemoveFavoriteSuccess: "Tu elemento ha sido eliminado de los favoritos exitosamente. Ya no aparecerá en el acceso rápido",
        RemoveFavoriteFailure: "NNo fue posible eliminar tu elemento de los favoritos. Verifica si ya ha sido eliminado. Si el error persiste, contacta al soporte"
      },
      Minicard: {
        File: "Archivo",
        Folder: "Carpeta",
        Desfav: "Quitar de favoritos",
        fav: "Favorito",
        NothingViewMiniCardTitle: "No hay elementos guardados",
        NothingViewMiniCardContent: "No se han guardado elementos aún.",
        NothingViewMiniCardWorkspaceTitle: "No hay espacio de trabajo guardado.",
        NothingViewMiniCardWorkspaceContent: "No se han guardado espacios de trabajo aún.",
        NothingViewMiniCardWorkspaceTitleAdm: "No hay espacio de trabajo guardado.",
        MiniCardAllFavoritesTitle: "Todos los espacios de trabajo fueron marcados como favoritos.",
        MiniCardAllFavoritesContent: "Todos tus espacios de trabajo están en la sección de favoritos",
        NothingViewMiniCardWorkspaceContentAdm: "Como administrador, ¡puedes crear un espacio de trabajo haciendo clic aquí!"

      },
      LogErrors: {
        browser: "Navegador",
        errorFound: "Error encontrado",
        createdDate: "Fecha de creación",
        server: "Servidor",
        method: "Método",
        stackTrace: "Seguimiento de pila",
        userMail: "Email del usuario",
        line: "Línea",
        search: "Buscar..."
      },
      FileNotFound: {
        message: "Archivo no encontrado"
      },
      Divider: {
        message: "o"
      },
      Navbar: {
        placeholderImputText: "¿Qué estás buscando...",
        labelCheckbox: "Solo en esta carpeta"
      },
      ShareFileComp: {
        share: "Compartir",
        firstTitle: "Para compartir el elemento de abajo con otros usuarios, por favor rellena los campos de acuerdo con los requisitos de compartir.",
        advancedOptions: "Opciones avanzadas",
        hasWatermark: "Contiene marca de agua",
        sharetilDate: "Compartir hasta fecha",
        limitAccess: "Limitar conteo de acceso",
        dontLimitAccess: "Compartir sin expirar acceso",
        shareWith: "Compartir con",
        back: "Atrás",
        textWord: "Texto (Word)",
        orientation: "Orientación",
        SaveWatermark: "Guardar marca de agua",
        editWatermark: "Editar marca de agua",
        shareSuccess: "Compartir archivo completado exitosamente."
      },
      Snackbar: {
        success: "¡Éxito!",
        Atention: "¡Atención!",
        Error: "¡Error!",
        Information: "¡Información!"
      },
      Drag: {
        NotPossible: "No se permite arrastrar elementos mientras se edita."
      },
    Sidebar: {
      QuickAccess: "Acceso rápido",
      Home: "Inicio",
      Dashboard: "Panel de control",
      Feed: "Actualizaciones",
      Groups: "Grupos",
      Pendencies: "Pendencias",
      Users: "Usuarios",
      Documents: "Documentos",
      ValidationRules: "Reglas de validación",
      Temporality: "Temporalidad",
      Preferences: "Preferencias",
      CloseSidebar: "Cerrar barra lateral",
      Organizations: "Organizaciones",
      Privileges: "Privilegios"
  },
    OrganizationConfig: {
    OrganizationInformation: "Información de la Organización",
    Name: "Nombre",
    Save: "Guardar",
    Cancel: "Cancelar",
    ServiceUser: "Usuario de servicio",
    Select: "Seleccione...",
    ElectronicSignature: "Firma electrónica",
    SuccessfullyEdited: "Editado con éxito",
    SuccessfullyChanged: "Cambiado con éxito",
    SomethingWentWrong: "Algo salió mal",
    ChangesCanceled: "Cambios cancelados",
    OrganizationNotFound: "Organización no encontrada",
    ErrorGettingSafe: "Error al obtener la caja fuerte"
  },
  Register: {
    NullOrg: "El nombre de la organización no puede estar vacío",
    OrgName: "Nombre de la organización",
    PassNull: "Las contraseñas no pueden estar vacías",
    Password: "Contraseña",
    ConfirmPassword: "Confirmar contraseña",
    TypeHere: "Escribe aquí...",
    Minimun8: "Mínimo de 8 caracteres",
    AnUpperCaseLetter: "Una letra mayúscula",
    ASpecialLetter: "Un carácter especial",
    Numeric: "Un carácter numérico",
    PasswordMatch: "Las contraseñas coinciden",
    FirstPageError: "Los campos deben completarse correctamente.",
    Username: "Nombre de usuario",
    Email: "Correo electrónico",
    WantSendingEmail: "Quiero recibir correos electrónicos con actualizaciones importantes y avisos de la plataforma.",
    IamOkPrivacy: "Acepto los Términos de Servicio y la Política de Privacidad",
    BackToLogin: "Volver al inicio de sesión",
    AlreadyHaveAccount: "¿Ya tienes una cuenta? ",
    BeOkWithBoth: "Debes aceptar nuestras políticas y la recepción de correos electrónicos."
  },
    AdminConsole: {
      SetUserAdminSystem: "Agregar usuario como administrador del sistema",
      UnSetUserAdminSystem: "Quitar usuario como administrador del sistema",
      SetUserAdmin: "Renombrar usuario como administrador",
      UnSetUserAdmin: "Quitar usuario como administrador",
      Preferencias: {
        Title: "Preferencias",
        SubTitle: "",
        OrgInfo: "Información de la organización",
        OrgPreferences: "Preferencias de la organización",
        OrgPreferencesSub: "Aquí encontrarás las configuraciones generales que aplican a toda la organización.",
        Storage: "Almacenamiento",
        AllowDrive: "Asignar permiso para el drive",
        D4sign: "Firma electrónica",
        Refresh: "Actualizar",
        Delete: "Eliminar",
        Save: "Guardar",
        UserService: "Usuario de servicio"
      },
      ErroContractTitle: "Ocurrió un error",
      ErrorContract: "Hubo un error relacionado con la recuperación de su contrato y ya estamos resolviéndolo. Si el problema persiste, contacte al soporte.",
      Hello: "Hola,",
      TestUser: " ¡Usuario de prueba!",
      User: "Usuario",
      HereYouHaveAccessToYour: "Aquí tienes acceso a tu",
      AdminPanel: " panel de administración,",
      YouWillFindAllTheToolsYouNeedToManageYourSubscription: " encontrarás todas las herramientas que necesitas para gestionar tu suscripción.",
      AccountAndSubscription: "Cuenta y suscripción",
      ManageYourAccountAndSubscriptionEnsuringFullControlOverImportantSettings: "Gestiona tu cuenta y suscripción, asegurando control total sobre configuraciones importantes.",
      FollowRealTimeUpdatesAndNotificationsToStayInformedAboutImportantActivities: "Sigue actualizaciones y notificaciones en tiempo real para mantenerte informado sobre actividades importantes.",
      UsersAndGroups: "Usuarios y grupos",
      EfficientlyLearnAboutUsersAndGroupsToFacilitateCollaborationAccessControlAndPermissions: "Aprende eficientemente sobre usuarios y grupos para facilitar la colaboración, control de acceso y permisos.",
      CheckOutAndManageOrganizationsViewingDetailsLikeStorageAndSettings: "Revisa y gestiona organizaciones, viendo detalles como almacenamiento y configuraciones.",
      BrowseTheAvailablePlansCompareFeaturesAndChooseTheBestOptionForYourNeeds: "Explora los planes disponibles, compara características y elige la mejor opción para tus necesidades.",
      SEEMORE: "VER MÁS",
      ReturnToAccount: "Volver a la cuenta",
      NeedToTalkToSupport: "¿Necesitas hablar con soporte?",
      ContactOurSupportTeamByClickingTheButtonBelow: "Contacta a nuestro equipo de soporte haciendo clic en el botón de abajo.",
      GetInContact: "Ponerse en contacto",
      Users: "Usuarios",
      Groups: "Grupos",
      Privileges: "Privilegios",
      Privilege: "Privilegio",
      WhatAreYouLookingFor: "¿Qué estás buscando...",
      NewUser: "Nuevo usuario",
      NewGroup: "Nuevo grupo",
      Name: "Nombre",
      GroupName: "Nombre del grupo",
      Phone: "Teléfono",
      Participants: "Participantes",
      EditInfo: "Editar información",
      Save: "Guardar",
      Cancel: "Cancelar",
      Back: "Atrás",
      UsersInfo: "Información de usuarios",
      GroupsInfo: "Información de grupos",
      AvailableGroups: "Grupos disponibles",
      LoginWithTwoFa: "Login con autenticación de dos factores",
      EnableTwoFa: "Habilita esta opción para permitir al usuario iniciar sesión en el sistema usando autenticación de dos factores.",
      AllowTwoFa: "Permitir login con autenticación de dos factores.",
      TypeUserName: "Introduce el nombre del usuario aquí...",
      Select: "Seleccionar...",
      TypeUserEmail: "Introduce el email del usuario aquí...",
      TypeUserPhone: "Introduce el teléfono del usuario aquí...",
      TypeGroupName: "Introduce el nombre del grupo aquí...",
      AddUser: "Agregar usuario",
      NoUsers: "No hay usuarios agregados",
      Owner: "Propietario",
      Administrators: "Administradores",
      AddUsersToGroup: "Rellena el campo de arriba y agrega usuarios al grupo.",
      WorkspaceQuantityNotAllowedTitle: 'No se pueden crear más espacios de trabajo.',
      WorkspaceQuantityNotAllowedContent: 'Se ha alcanzado el límite de espacios de trabajo permitido para su plan. Para crear más espacios de trabajo, contacte con soporte o visite la página de planes para actualizar.',
      ReturnToWorkspacePage: 'Volver a la página de Espacios de trabajo',
      UsersMin: "usuarios",
      GroupsMin: "grupos",
      Showing: "Mostrando",
      Total: "total",
      Of: "de",
      MeAnd: "@Yo y",
      UsersParticipates: "Usuarios participan",
      InvalidUsername: "Introduce al menos 3 dígitos.",
      InvalidEmail: "El email introducido no es válido.",
      InvalidPhone: "Introduce 11 dígitos o ninguno",
      DisableGroupModalTitle: "¿Quieres eliminar el grupo?",
      DialogDeleteGroupStart: "Confirma que realmente te gustaría eliminar permanentemente el",
      DialogDeleteGroupEnd: "grupo. Una vez removido, no será posible recuperarlo.",
      UserRemovedFromGroup: "Usuario removido del grupo",
      DisableGroup: "Deshabilitar grupo",
      GroupCreated: "Grupo creado exitosamente",
      Organizer: "Organizador",
      Validator: "Validador",
      Reader: "Lector",
      RootSubtitle: "Tienes acceso completo a todas las funcionalidades del sistema, incluyendo crear y gestionar carpetas y documentos, entre otras opciones.",
      OwnerSubtitle: "Te permite hacer ediciones a la herramienta y acceder a sus funciones. Sin embargo, no puedes crear o eliminar estructuras de carpetas.",
      OrganizerSubtitle: "No tiene acceso a privilegios administrativos y no puede cambiar la carpeta raíz, pero puede crear nuevas subcarpetas y documentos, así como editar y eliminar contenido existente. Las subcarpetas heredarán automáticamente los mismos privilegios que grupos y usuarios en la carpeta raíz.",
      EditorSubtitle: "Hacer ediciones en la herramienta y tener acceso a las funciones. No puedes crear y eliminar estructuras de carpetas.",
      ValidatorSubtitle: "Te permite consultar, ver y descargar documentos. También ofrece funciones para aprobar y firmar documentos.",
      ReaderSubtitle: "Estos usuarios solo consultan y ven documentos en espacios de trabajo permitidos.",
      ResetPasswordEmail: "Email de restablecimiento de contraseña enviado",
      RemoveGroup: "Remover del grupo",
      DisableUser: "Deshabilitar usuario",
      EditUserInfo: "Editar información",
      ResetPassword: "Restablecer contraseña",
      DoesNotHave: "No tiene",
      WorkspaceSubtittle: "Aquí puedes ver todos los espacios de trabajo existentes en esta organización.",
      NewWorkspace: "Nuevo espacio de trabajo",
      NotFoundWorkspace: "No hay espacios de trabajo aún",
      NoFoundWorkspaceSubtittle: "Únete o crea un espacio de trabajo y entonces el espacio de trabajo aparecerá disponible aquí.",
      NoDescription: "Sin descripción",
      UsersWithAccess: "Usuarios con acceso",
      Documents: "Documentos",
      NewWorkspaceTitle: "Nuevo espacio de trabajo",
      UpdateWorkspaceTitle: "Actualizar espacio de trabajo",
      CreateWorkspace: "Crear espacio de trabajo",
      UpdateWorkspace: "Actualizar espacio de trabajo",
      CreatingYourWorkspace: "Estamos creando tu espacio de trabajo. Espera un momento.",
      UpdateYourWorkspace: "Estamos actualizando tu espacio de trabajo. Espera un momento.",
      CreatingWorkspace: "Creando espacio de trabajo",
      UpdatingWorkspace: "Actualizando espacio de trabajo",
      CreatingYourWorkspaceDialog: 'El espacio de trabajo ha sido creado exitosamente! Haz clic en "Continuar" para ver la lista de espacios de trabajo y acceder a ellos.',
      UpdateYourWorkspaceDialog: 'El espacio de trabajo ha sido actualizado exitosamente! Haz clic en "Continuar" para ver la lista de espacios de trabajo y acceder a ellos.',
      CreatingYourWorkspaceDialogTitle: 'Todo listo',
      Duplicate: "Clonar",
      Edit: "Editar",
      Favorite: "Favorito",
      Unfavorite: "Quitar de favoritos",
      Delete: "Eliminar",
      Confirm: "Confirmar",
      Continue: "Continuar",
      DeleteDialogTextPart1: "Confirma que realmente te gustaría eliminar permanentemente el ",
      DeleteDialogTextPart2: "espacio de trabajo. Una vez removido, no será posible recuperarlo.",
      DeleteDialogTitle: "¿Quieres eliminar el espacio de trabajo?",
      WorkspaceName: "Nombre del espacio de trabajo",
      ValidationWorkspaceName: "El nombre debe tener 3 o más caracteres",
      WorkspaceDescription: "Descripción del espacio de trabajo",
      Rules: "Reglas",
      UploadAsRealease: "Subir como liberación",
      CadBackground: "Generar datos de vista previa del archivo. CAD en segundo plano",
      NoUsersInWorkspace: "No hay usuarios en el espacio de trabajo",
      NoUsersInWorkspaceSub: "Rellena el campo de arriba y agrega usuarios al grupo.",
      TheWorkspaceDoesNotHaveAnyLinkedUsersYet: "El espacio de trabajo aún no tiene usuarios vinculados.",
      CommonUsers: "Común",
      ReadUsers: "Lector",
      EditUsers: "Editor",
      ViewUsers: "Visualizador",
      OrganizeUsers: "Organizador",
      SeeAll: "Ver todo",
      ClientInformation: "Información del cliente",
      Company: "Empresa",
      Responsible: "Responsable",
      ResponsiblePersonEmail: "Email de la persona responsable",
      CellPhone: "Teléfono celular",
      ContractInformation: "Información del contrato",
      ContractNumber: "Número de contrato",
      TermOfTheContract: "Término del contrato",
      TotalContractValue: "Valor total del contrato",
      Organizations: "Organizaciones",
      Server: "Servidor",
      Plan: "Plan",
      Plans: "Planes",
      Category: "Categoría",
      Storage: "Almacenamiento",
      LoginWithOffice365: "Login con Office 365",
      DescriptionLoginWithOffice365: "Esta opción permite al usuario iniciar sesión en el sistema usando su cuenta de Microsoft.",
      AllowsLoginWithOffice365: "Permite login con Office 365",
      ContactOurSupportTeamByClickingTheButtonNextToIt: "Contacta a nuestro equipo de soporte haciendo clic en el botón al lado.",
      NoExistingContract: "No hay contrato existente",
      DescriptionNoExistingContract: "Parece que no se ha creado ningún contrato aún.",
      DashboardSubtitle: "Acompaña datos y métricas esenciales de forma intuitiva para optimizar decisiones y monitorear el rendimiento con eficiencia.",
      RedirectToHomeOnContinue: "Al hacer clic en Continuar, el cambio se realizará y serás redirigido automáticamente a la página de inicio de la organización. ¿Deseas continuar?"
    },
    Feed: {
      Updates: "Actualizaciones",
      HeaderText: "Aquí, encontrarás todas las noticias y cambios relacionados con los documentos.",
      NonExistingUpdates: "Actualizaciones inexistentes",
      NonExistingUpdatesText: "Parece que no ha habido movimiento hasta ahora. Por favor inténtalo de nuevo más tarde.",
      NoContentWithFilter: "Desafortunadamente no se encontraron actualizaciones para el filtro aplicado. Por favor inténtalo de nuevo.",
      NoContentFound: "No se encontraron actualizaciones",
      AssignedTo: "Asignado a",
      ShowAll: "Mostrar todo (Por defecto)",
      Term: "Término",
      Start: "Inicio",
      End: "Fin",
      Reset: "Restablecer",
      ApplyFilter: "Aplicar filtro",
      Today: "Hoy",
      Yesterday: "Ayer",
      PreviousUpdates: "Actualizaciones anteriores",
      SeeMore: "Ver más",
      Filters: "Filtros",
    },
    MyData: {
        Mydata: "Mis datos",
        Cancel: "Cancelar",
        Save: "Guardar",
        PersonalizeExp: "Personaliza tu experiencia estableciendo tu foto de perfil, proporcionando tus detalles, y manteniendo tu contraseña segura y actualizada.",
        UploadImageTerms: "Sube una imagen de al menos 800x800px (recomendado). Solo se aceptan formatos .JPG o .PNG.",
        Userimage: "Imagen del usuario",
        PersonaInformation: "Información personal",
        Name: "Nombre",
        PhoneNumber: "Número de teléfono/Celular",
        Pass: "Contraseña",
        Login: "Email",
        CurrentPass: "Contraseña actual",
        ChangePass: "Cambiar contraseña",
        ContantSup: "¿Necesitas contactar soporte?",
        ContantTeam: "Contacta a nuestro equipo de soporte haciendo clic en el botón al lado",
        GetIn: "Ponerse en contacto",
        Uploadimage: "Subir imagen",
        Language: "Idioma",
        Logout: "Cerrar sesión",
        NewPassword: "Nueva contraseña",
        ConfirmPassword: "Confirmar contraseña",
        ChangeImage: "Cambiar imagen",
        Remove: "Remover",
        UserEdittedSuccessfully: "Usuario fue actualizado exitosamente"
    },
    BatchActionModal: {
        actionLabel: "Acciones de documento",
        actionSublabel: "Ve los documentos aprobables y no aprobables basados en las acciones en lote.",
        batchAprovable: "Aprobable en lotes",
        nonBatchAprovable: "No aprobable",
        documentName: "Nombre del documento",
        reproveButton: "Desaprobar documentos",
        aproveDocument: "Aprobar documentos",
        approvedDocuments: "¡Documentos aprobados exitosamente!",
        approvedDocumentsSub: "Los documentos listados abajo han sido aprobados exitosamente.",
        concluded: "Concluir",
        reprovedDocuments: "¡Documentos rechazados exitosamente!",
        reprovedDocumentsSub: "Los documentos listados abajo han sido rechazados exitosamente."
      },
    DocumentsList: {
      DocumentsTableHeaders: {
        Name: "Nombre",
        Description: "Descripción",
        CreatedAt: "Creado en",
        Tags: "Etiquetas",
        Size: "Tamaño",
        Term: "Término",
      },
      SeeDocuments: "Ver documentos"
    },
    SearchBox: {
        recentSearches: "Búsquedas recientes",
        noRecentLists: "No hay búsquedas recientes",
        searchButton: "Buscar",
        cleanSearches: "Limpiar búsqueda",
        seeAllResults: "Ver todos los resultados",
        tryOtherWords: "Intenta buscar con otras palabras para tratar de encontrar lo que buscas.",
        nothingFound: "No se encontró nada",
        bestResults: "Mejores resultados",
        searchForContent: "Buscar sobre contenido",
        allWorkspaces: "Todos los espacios de trabajo",
        inThatPage: "En esa página",
        myFolderAndFiles: "Mis carpetas y archivos",
        selectOrg: "Selecciona tu organización.",
        selectedWorkspace: "Selecciona tu espacio de trabajo.",
        default: "Por defecto"
    },
    PasswordMessage: {
      MinLength: "La contraseña es más corta de lo esperado. El mínimo es 6.",
      AtLeastOneNumber: "La contraseña requiere al menos 1 número.",
      EspecialValidation: "La contraseña requiere al menos un carácter especial.",
      UppercaseValidation: "La contraseña requiere al menos un carácter en mayúscula.",
      DiffPass: "Las contraseñas difieren.",
      StartProcess: "Escribe tu contraseña actual...",
      changedSuccessfully: "Contraseña cambiada exitosamente."
    },
    Language: {
      Language: "Idioma",
      SelectPreferIdiom: "Selecciona tu idioma preferido.",
      NotFoundLanguage: "¿No encuentras tu idioma? Contacta nuestro soporte para solicitar un idioma específico."
    },
    OpeningDocumentInWindows: {
      message: "Abriendo documento en Windows",
    },
    DownloadAgentModal: {
      haveThe: "Tienes el",
      onYourComputer: "en tu computadora",
      toViewTheSelectedItemOnYourComputerClickTheButtonBelowToDownloadAndInstallThe: "Para ver el elemento seleccionado en tu computadora, haz clic en el botón de abajo para descargar e instalar el",
      cancel: "Cancelar",
      downloadKeyDriveLocalEdit: "Descargar KeyDriveLocalEdit",
      openInApplication: "Abrir en aplicación",
      OpeningDocumentInKeyDriveLocalEdit: "Abriendo documento en KeyDriveLocalEdit",
      UnsupportedBrowser: "Navegador no soportado",
    },
    MoveInBatch: {
      "title": "¿Mover elementos seleccionados?",
      "header": "Por favor confirma si realmente quieres mover todos los elementos seleccionados abajo. Finalmente, establece el destino para los elementos.",
      "titleListItens": "Elementos seleccionados",
      "titleMoveFor": "Mover a",
      "checkbox": "Mover a la raíz del espacio de trabajo"
    },
    SelectedList: {
      Name: "Nombre",
      ItemSelected: "elemento seleccionado",
      ItemsSelected: "elementos seleccionados"
    },
    MovedSuccess: {
      "title": "Elementos movidos exitosamente",
      "header": "¡Todo listo! Los elementos seleccionados han sido movidos exitosamente. Revísalos abajo:",
      "goToLocation": "Ir a ubicación",
      "finish": "Finalizar"
    },
    BoxMfa: {
      title: "Autenticación de dos factores",
      button: "Volver al login"
    },
    MfaQRCode: {
      header: "Sigue los pasos de abajo para acceder a tu cuenta.",
      tooltip: "Copiar código",
      tipPartA: "¿No puedes escanear el código?",
      tipPartB: " Copia el código de arriba y pégalo en tu autenticador.",
      tipOnePartA: "Escanea el código QR",
      tipOnePartB: " al lado usando la aplicación de autenticación (ej., Authenticator).",
      tipTwo: "Después de escanear, introduce el código de 6 dígitos recibido en los campos de abajo:"
    },
    MfaOTP: {
      header: "Ya tienes el código QR. Ahora, introduce el código recibido en tu aplicación autenticadora en los campos de abajo:",
      buttonNotQRCode: "No tengo el código QR",
      workspaceStart: "Solo puedes tener " ,
      workspaceBold: "un espacio de trabajo en el plan gratuito. ",
      workspaceEnd: "Contacta soporte y solicita una actualización al plan de tu organización.",
      usersStart: "Solo puedes tener  ",
      usersBold: "tres usuarios en el plan gratuito. ",
      usersEnd: "Contacta soporte y solicita una actualización al plan de tu organización.",
      storageStart: "Solo puedes usar hasta  ",
      storageBold: "4GB de almacenamiento en el plan gratuito. ",
      storageEnd: "Contacta soporte y solicita una actualización al plan de tu organización.",
      storageWithAdminContact: "Solo puedes usar hasta  ",
      storageWithAdminContactBold: "4GB de almacenamiento en el plan gratuito. ",
      storageWithAdminContactEnd: "Contacta al usuario administrador y solicita una actualización al plan de la organización.",
      validationRuleStart: "Solo puedes tener ",
      validationRuleBold: "una regla de validación en el plan gratuito. ",
      validationRuleEnd: "Contacta soporte y solicita una actualización al plan de tu organización.",
      upgrade: "Solicitar actualización",
      gotIt: "Entendido",
      error: "Error al solicitar datos de la organización, por favor inténtalo de nuevo"
    },
        SharedItem: {
            Title: "Compartido",
            Subtitle: "Aquí puedes ver todas las carpetas y archivos que han sido compartidos con usuarios colaboradores.",
            NotFound: {
            Title: "No hay elementos compartidos",
            Subtitle: "Aún no se han compartido elementos."
            },
            name: "Nombre",
            dateShared: "Fecha de expiración",
            sharedBy: "Compartido por",
            usersWithAccess: "Usuarios con acceso",
            users: "Usuarios",
            theDocument: "El documento",
            hasBeenSharedSuccessfully: "ha sido compartido exitosamente.",
            favoriteSuccess: "Documento marcado como favorito con éxito.",
            favoriteFail: "el favorito ya existe.",
            unfavoriteSuccess: "Documento eliminado de favoritos con éxito.",
            unfavoriteFail: "Error al quitar de favoritos.",
            unsharedSuccess: "No compartido con",
            unsharedFail: "Error al dejar de compartir.",
            all: "todos",
            noExpiration: "Sin expiración",
        },
        GenericTablePagination: {
            showing: "Mostrando",
            itemsOutOf: "elementos de un total de",
            totalItems: "elementos totales."
        },
        ItemOptionsMenu: {
            download: "Descargar",
            edit: "Editar",
            copyLink: "Copiar enlace",
            favorite: "Favorito",
            unfavorite: "Quitar de favoritos",
            unshared: "Dejar de compartir",
            all: "Todos"
        },
        ButtonWithPopoverFilter: {
            filters: "Filtros",
            viewAll: "Ver todo",
            myFiles: "Mis archivos",
            sharedBy: "Compartido por",
            select: "Seleccionar...",
            sharedDate: "Fecha de compartición",
            start: "Inicio",
            end: "Fin",
            reset: "Restablecer",
            applyFilter: "Aplicar filtro"
        },
    PleaseWaitTheOrganizationIsBeingCreated: {
      message: "Por favor espera, la organización está siendo creada."
    },
    NewFolder: {
      title: "Nueva carpeta"
    },
    WorkspaceList: {
        Documents: "Documentos",
        HeaderText: "Administre sus documentos: siga fácilmente el estado de pendientes, aprobaciones y rechazos.",
        DocumentActions: "Acciones en documentos",
        New: "Nuevo",
        NoItens: "No hay elementos aquí",
        NoItensText: "Desafortunadamente, no hay documentos o carpetas disponibles en este momento."
    },
    DocumentActionsMenu: {
        draft: "Borrador",
        download: "Descargar",
        release: "Publicar",
        moveTo: "Mover a",
        preValidationOfAction: "Prevalidación de la acción",
        BatchDelete: "Eliminar en lote"
    },
    DeleteInBatchDialog: {
      Title: "Los elementos a continuación se han movido a la papelera",
      ErrorWhenDeletingFiles: "Hubo un error al intentar eliminar sus archivos.",
      DeletedSuccessfully: "Eliminado con éxito",
      Selected: "Seleccionados",
      NotDeleted: "No eliminados",
      GoToRecycleBin: "Ir a la papelera",
      Close: "Cerrar",
      Name: "Nombre",
      Extension: "Extensión",
      Reason: "Razón",
      ConfirmDialogTitle: "¿Eliminar elementos seleccionados?",
      ConfirmDialogContent: "Confirma si realmente quieres eliminar permanentemente los elementos seleccionados abajo.",
      AlertTitle: "Observación",
      AlertSubtitle: "Para recuperar los elementos eliminados, acceda a la sección Papelera y siga las instrucciones de la página."
    },
    ChoosePlan: {
      title: "Planes KEY",
      subtitle: "Solución segura y escalable para la gestión de documentos.",
      essentialPlan: "Esencial",
      professionalPlan: "Professional",
      scalePlan: "Scale",
      perMonth: "/mes",
      mostPopular: "Más Popular",
      upToUsers: "Hasta {{count}} usuarios",
      storage: "{{size}} de almacenamiento",
      workspace: "{{count}} workspace",
      workspaces: "Hasta {{count}} workspaces",
      unlimitedWorkspaces: "Workspaces ilimitados",
      groupPermissions: "Permisos por grupo",
      versionControl: "Control de versiones",
      emailSupport: "Soporte vía email",
      workflowRules: "Reglas de workflow y temporalidad",
      externalAPIs: "APIs externas y auditoría",
      chatSupport: "Soporte vía chat",
      cadViewer: "Visualizador CAD",
      coldStorage: "Cold Storage inteligente",
      advancedReports: "Informes avanzados",
      dedicatedSupport: "Soporte dedicado",
      startTrial: "Iniciar evaluación",
      confirmSubscription: "Confirmar Suscripción",
      cancel: "Cancelar",
      plan: "Plan",
      cardDetails: "Datos de la Tarjeta",
      billingAddress: "Dirección de Facturación",
      completeSubscription: "Completa tu suscripción",
      processingSubscription: "Procesando tu suscripción",
      validatingData: "Validando datos",
      creatingPaymentMethod: "Creando método de pago",
      processingSubscriptionStep: "Procesando suscripción",
      finalizing: "Finalizando",
      subscriptionCompleted: "¡Suscripción completada!",
      congratulations: "¡Felicitaciones! Tu suscripción ha sido procesada con éxito.",
      subscriptionDetails: "Detalles de la suscripción:",
      value: "Valor:",
      email: "Email:",
      confirmationEmail: "Recibirás un email de confirmación en breve.",
      errorProcessing: "Error al procesar suscripción",
      whatToDoNow: "¿Qué hacer ahora?",
      checkCardData: "• Verifica los datos de la tarjeta e intenta nuevamente",
      ensureFieldsFilled: "• Asegúrate de que todos los campos estén completados correctamente",
      contactSupport: "• Si el problema persiste, contacta al soporte",
      tryAgain: "Intentar nuevamente",
      notReadyToSubscribe: "¿No estás listo para suscribirte ahora?",
      startUsing: "Comenzar a usar",
      subscribeNow: "Suscribirse ahora",
      personalPlanAlert: "Estás utilizando un plan personalizado. Para contratar un plan, contacta con el soporte.",
      logoutToRefreshSubscription: "¡Cierra sesión y vuelve a entrar en la aplicación para actualizar tu suscripción!",
      alreadyHaveSubscriptionError: "• Si ya tienes una suscripción, no puedes suscribirte nuevamente. Si necesitas una actualización, contacta a nuestro soporte.",
      UsingFreePlan: "Estás usando una versión gratuita del software", 
      FreeAdmPlan: "Para actualizar, entra en la consola de administración y accede a nuestra pestaña de planes!", 
      NotFreeAdmPlan: "Para actualizar, contacta al administrador de tu organización!"
    }
    ,
    FreeSoftwareAlert: {
      title: "Estás usando una versión gratuita del software",
      admin: "Para actualizar, entra en la consola de administración y accede a nuestra pestaña de planes!",
      user: "Para actualizar, contacta con el administrador de tu organización!",
      button: "Acceder a Planes"
    }
  }
}